/**
 * The scope this report runs under: one property, and nothing else.
 *
 * The Sitemaps API answers about what was submitted for a property as it stands now — there is no
 * window, no surface and no comparison to choose — so none of the shared period fields apply and
 * the address carries only the property. The record filter is not part of the scope: it narrows
 * the records already returned, in the browser, and changes nothing about the request.
 */

/** The query-string keys this report owns. */
export const URL_KEYS = ['site'];

export function initialDraft() {
    return { siteUrl: '', permissionLevel: '' };
}

export function resolveReportScope(draft, t) {
    const errors = [];
    if (!draft.siteUrl) errors.push(t('tools.gsc.errors.no_property'));

    return { siteUrl: draft.siteUrl, errors, warnings: [] };
}

/** Whether the address names a property — which is what makes the report load on arrival. */
export function hasReportScope(params) {
    return !!params.site;
}

export function reportDraftFromParams(params) {
    return params.site ? { siteUrl: params.site } : {};
}

export function reportParamsFromScope(scope) {
    return { site: scope.siteUrl };
}
